module.exports = __webpack_public_path__ + "static/media/close-btn.cef1de1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sideMenu/icons/close-btn.svg
// module id = 83
// module chunks = 0